import { createQueryHook } from '../../createQueryHook'
import { DelegateUser } from '../../types'

export default createQueryHook<undefined, { items: DelegateUser[] }>({
  getKey: () => ['/account/user-delegation/my-delegated-users'],
  getEndpoint: () => '/account/user-delegation/my-delegated-users'
})
